var _style, _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMediaIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.media-icon-white-st0{clip-path:url(#SVGID_00000003073965468303763380000006571563262321142407_);}\n\t.media-icon-white-st1{fill:#015BD7;enable-background:new    ;}\n\t.media-icon-white-st2{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n\t.media-icon-white-st3{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 24,
    height: 24
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000140702298119385464740000014654786072499831206_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000140702298119385464740000014654786072499831206_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "media-icon-white-st2",
    d: "M20.2,4.5H3.8C3.3,4.5,3,4.8,3,5.2v13.5c0,0.4,0.3,0.8,0.8,0.8h16.5c0.4,0,0.8-0.3,0.8-0.8V5.2 C21,4.8,20.7,4.5,20.2,4.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "media-icon-white-st2",
    d: "M3,15.8L7.7,11C7.8,11,7.9,10.9,8,10.9c0.1,0,0.2-0.1,0.3-0.1s0.2,0,0.3,0.1c0.1,0,0.2,0.1,0.2,0.2l4.2,4.2 c0.1,0.1,0.2,0.1,0.2,0.2c0.1,0,0.2,0.1,0.3,0.1s0.2,0,0.3-0.1c0.1,0,0.2-0.1,0.2-0.2l1.9-1.9c0.1-0.1,0.2-0.1,0.2-0.2 c0.1,0,0.2-0.1,0.3-0.1s0.2,0,0.3,0.1c0.1,0,0.2,0.1,0.2,0.2l4,4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "media-icon-white-st3",
    d: "M14.6,10.5c0.6,0,1.1-0.5,1.1-1.1s-0.5-1.1-1.1-1.1s-1.1,0.5-1.1,1.1S14,10.5,14.6,10.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaIconWhite);
export default __webpack_public_path__ + "static/media/media-icon_white.5480c5b12e697148011d60eba5a728a0.svg";
export { ForwardRef as ReactComponent };